export default "__VITE_ASSET__dd5bfa77__"